/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsPlayerChampionPlayDtoSchema } from "./playerChampionPlayDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamPlayerStatsDtoSchema = z.object({
  userId: z.string().nullish(),
  displayName: z.string().nullish(),
  username: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  role: z.string().nullish(),
  isCaptain: z.optional(z.boolean()),
  hasPro: z.optional(z.boolean()),
  proNicknameStyle: z.optional(z.int()),
  proNicknameColorA: z.string().nullish(),
  proNicknameColorB: z.string().nullish(),
  games: z.optional(z.int()),
  avgKills: z.optional(z.number()),
  avgDeaths: z.optional(z.number()),
  avgAssists: z.optional(z.number()),
  kda: z.optional(z.number()),
  killParticipation: z.optional(z.number()),
  avgCs: z.optional(z.number()),
  avgVisionScore: z.optional(z.number()),
  get champions() {
    return z.array(goodLuckCoreDTOsPlayerChampionPlayDtoSchema).nullish();
  },
});
